<mat-toolbar>{{ 'userAccount.myAccount' | translate }}</mat-toolbar>
<mat-tab-group>
  <mat-tab [label]="'userAccount.infosTabTitle' | translate | uppercase">
    <ng-template matTabContent>
      <mat-card>
        <mat-card-content>
          <p>
            <strong>{{ 'userAccount.lastname' | translate }}:</strong>
            {{ account?.account_lastname }}
          </p>
          <p>
            <strong>{{ 'userAccount.firstname' | translate }}:</strong>
            {{ account?.account_firstname }}
          </p>
          <p>
            <strong>{{ 'userAccount.email' | translate }}:</strong>
            {{ account?.account_email }}
          </p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-title class="general-info">{{ 'userAccount.generalInfomrations' | translate }}</mat-card-title>
        <mat-card-content>
          <p>{{ 'userAccount.dsSixenseProduct' | translate }}</p>
          <p>
            {{ 'userAccount.supportMessage' | translate }} :
            <a href="mailto:{{ supportEmail }}">{{ supportEmail }}</a>
          </p>
        </mat-card-content>
      </mat-card>

      <mat-card>
        <mat-card-title>{{ 'userAccount.preferences' | translate }}</mat-card-title>
        <mat-card-content>
          <ds-lib-language-picker [(language)]="currentLanguage" (languageChange)="onLanguageChange($event)">
          </ds-lib-language-picker>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </mat-tab>
</mat-tab-group>
